import { render } from "./TaxReportCustom2021.vue?vue&type=template&id=13525ab0&scoped=true"
import script from "./TaxReportCustom2021.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2021.vue?vue&type=script&lang=js"

import "./TaxReportCustom2021.vue?vue&type=style&index=0&id=13525ab0&scoped=true&lang=css"
import "./TaxReportCustom2021.vue?vue&type=style&index=1&id=13525ab0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13525ab0"]])

export default __exports__